module.exports = __webpack_public_path__ + "static/media/TimesUp.3a2db897.mp3";